import React from 'react';
import { NumberTextField } from '../BuildingBlocks/Form/NumberTextField';
import { useMobile } from '../../hooks/useMobile';
import Typography from '@material-ui/core/Typography/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  text: {
    fontWeight: 700,
    color: theme.palette.brand.greenDark,
  },
}));

interface IAverageUnitCost {
  register: any;
  errors?: any;
}
export default function AverageUnitCost({
  register,
  errors,
}: IAverageUnitCost) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });

  return (
    <>
      <Typography variant={'h6'} gutterBottom className={classes.text}>
        Looking at your COGS, what is your average unit cost?
      </Typography>
      <NumberTextField
        errors={errors}
        label={'Average unit cost'}
        name={'averageUnitCost'}
        // className={`${classes.noMarginBottom}`}
        TextFieldProps={{
          ...register('averageUnitCost', {
            required: {
              value: true,
              message: 'This field is required.',
            },
          }),
        }}
      />
    </>
  );
}
